import React, { useCallback, useEffect, useState } from "react";
import _debounce from "lodash/debounce";

import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
const SegmentSection = ({
  colIndex,
  segmentOptions,
  setSelectedSegment,
  selectedSegment,
}) => {
  const [segmentFilter, setSegmentFilter] = useState("");
  const [segmentOptionVal, setSegmentOptionVal] = useState(segmentOptions);

  useEffect(() => {
    setSegmentOptionVal(segmentOptions);
  }, [segmentOptions]);

  const handleDebounceFn = (inputValue) => {
    if (inputValue !== "") {
      const filteredOptions = segmentOptions.filter((option) =>
        option.heading.toLowerCase().includes(inputValue.toLowerCase()),
      );
      setSegmentOptionVal(filteredOptions);
    } else {
      setSegmentOptionVal(segmentOptions);
    }
  };

  const debounceFn = useCallback(_debounce(handleDebounceFn, 500), [
    segmentOptions,
  ]);

  return (
    <>
      {segmentOptions && segmentOptions?.length ? (
        <>
          <div className="search-filter">
            <span className="search-icon pi pi-search text-secondary pe-2"></span>
            <InputText
              name={`search_key_${colIndex + 1}`}
              value={segmentFilter}
              onChange={(e) => {
                setSegmentFilter(e.target.value);
                debounceFn(e.target.value);
              }}
              className="mb-2 column-input"
              placeholder={`Search Segments`} // Placeholder for each search
            />
          </div>
          <div className="scroll-panel-custom panel-height">
            {segmentOptionVal?.map((option, index) => (
              <div
                className="d-flex align-items-baseline pt-2 pb-2"
                key={index}
              >
                <RadioButton
                  inputId={`option-${index}`}
                  checked={selectedSegment === option.heading}
                  name="segment-value"
                  value={option.heading}
                  onChange={(e) => setSelectedSegment(e.value)}
                />
                <label
                  htmlFor={`option-${index}`}
                  className="ms-2"
                  // style={{
                  //     overflow: "hidden",
                  //     textOverflow: "ellipsis",
                  //     whiteSpace: "nowrap",
                  //     // minWidth: "165px",
                  //     // maxWidth: "165px"
                  // }}
                >
                  {option.heading}
                </label>
              </div>
            ))}
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default SegmentSection;
